<template>
   <div>
      <!-- Start the code for this screen here -->
      <div id="column">
      <div class="marginzero heading" ><span><b>Elements</b></span>
      <input class="clearbutton" type=button value="Clear" @click="clearElements()"></div>
      <div class="card card-height" style="" >
      <div  class="frm-group">
            <div class="col-16">
               <label for="initialEquity" > Initial Equity Target </label>
            </div>
            <div class="col-9" >
               <input type="text" v-model.number="quoteobject.quote.de_initial_equity_target_pct"
               @input="handleInput"/>
            </div>
            <div class="col-16">
               <label for="exitEquity" > Zipcode </label>
            </div>
            <div class="col-9">
               <input type="text" v-model.number ="quoteobject.quote.zip_code" @change="getzipcode()"/>
            </div>
            <div class="col-16">
                 <label for="netPayDealer"> Is Sale Leaseback </label>
            </div>
            <div class="col-9 font12">

                 <input type="radio" name="radio1" value="Y" v-model="quoteobject.quote.de_Is_Sale_Leaseback" class="maxwidth">Yes
                 <input type="radio" name="radio1" value="N" v-model="quoteobject.quote.de_Is_Sale_Leaseback" class="maxwidth">No
            </div>
                     </div>
         <div  class="frm-group" >
            <div class="col-16">
               <label for="exitEquity" > Exit Equity Target </label>
            </div>
            <div class="col-9">
               <input type="text" v-model.number ="quoteobject.quote.de_exit_equity_target_pct" @input="handleInput"/>
            </div>
            <div class="col-16">
               <label for="initialEquity" > City </label>
            </div>
            <div class="col-9">
               <input type="Text" v-model="quoteobject.quote.city"/>
            </div>
            <div class="col-16">
                 <label for="netPayDealer"> Is Deferred Down </label>
            </div>
            <div class="col-9 font12">
                 <input type="radio" name="radio1" value="Y" v-model="quoteobject.quote.de_is_deferred_down" class="maxwidth">Yes
                 <input type="radio" name="radio1" value="N" v-model="quoteobject.quote.de_is_deferred_down" class="maxwidth">No
            </div>

         </div>
         <div  class="frm-group" >
            <div class="col-30">
               <label for="initialWholeSaleValue"> Initial Whole Sale Value </label>
            </div>
            <div class="col-15">
               <label type="number" class="labelright"> {{calcInitialWholesaleValue}}</label>
            </div>
            <div class="col-30">
               <label for="state"> State of Registration </label>
            </div>
            <div class="col-15">
               <select name="State" v-model.trim="quoteobject.quote.de_state_of_registration"  data-vv-as="State" @change ="clearzipcode()">
          <option disabled value=""> Select a State </option>
             <option v-for="state in states" v-bind:value="state.stateAlphaC" v-bind:key="state.stateAlphaC">{{state.stateN}} </option>
        </select>
        <!-- <input v-model.trim="quoteobject.quote.de_state_of_registration"> -->
            </div>
            <div class="col-30">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
                <label for="loanFundingCost"> Initial Equity Target </label>
               </div>
            </div>
            <div class="col-15">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <input type="text" v-model.number="quoteobject.quote.de_initial_equity_target"/>
            </div>
            </div>
            <div class="col-30">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label for="initialWholeSaleValue"> Secondary Equity build period </label>
               </div>
            </div>
            <div class="col-15">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label type="number" class="labelright">{{calcSecondaryEquityPeriod}}</label>
               </div>
            </div>

            </div>
         <div  class="frm-group" >
            <div class="col-30">
               <label for="exitWholeSaleValue">Exit Whole Sale Value </label>
            </div>
            <div class="col-15">
               <label type="text" class="labelright">{{calcExitWholesaleValue}}</label>
            </div>
            <div class="col-30">
                 <label for="stateTaxRate"> State Tax Rate </label>
            </div>
            <div class="col-15">
                 <input type="text" v-model.number="quoteobject.quote.de_state_tax_rate_pct" />
            </div>
            <div class="col-30">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
                <label for="equityBuildPeriod(months)"> Equity Build period(Months) </label>
               </div>
            </div>
            <div class="col-15">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <input type="text" v-model.number="quoteobject.quote.de_equity_build_period"/>
               </div>
            </div>
            <div class="col-30">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label for="deferredEquityAmount">Deferred Equity Amount </label>
               </div>
            </div>
            <div class="col-15">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label type="text" class="labelright">{{ calcDeferredEquityAmount}}</label>
               </div>
            </div>

         </div>
         <div  class="frm-group" >
            <div class="col-30">
                <label for="loanFundingCost"> Loan Funding Cost </label>
            </div>
            <div class="col-15">
               <label type="text"></label>
            </div>
            <div class="col-30">
                 <label for="countyTaxRate"> County Tax Rate </label>
            </div>
            <div class="col-15">
                <input type="text" v-model.number="quoteobject.quote.de_county_tax_rate_pct" />
            </div>
            <div class="col-30">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label for="monthlyEquityBuildPayment">Monthly Equity Build Pmt </label>
               </div>
            </div>
            <div class="col-15">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label type="text" class="labelright">{{calcMonthlyEquityBuildPayment}}</label>
               </div>
            </div>
            <div class="col-30">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label for="TaxOnMonthlyEquityBuildPayment">Tax on Mtly Equity Build Pmt</label>
               </div>
            </div>
            <div class="col-15">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label type="text" class="labelright">{{calcTaxOnMonthlyEquityBuildPayment}}</label>
               </div>
            </div>

        </div>
        <div  class="frm-group" >
            <div class="col-30">
                 <label for="leaseFundingCost"> Lease Funding Cost </label>
            </div>
            <div class="col-15">
               <input type="text" v-model.number ="quoteobject.quote.de_lease_funding_cost_pct" @input="handleInput"/>
            </div>
            <div class="col-30">
                 <label for="zipTaxRate"> Zip Tax Rate </label>
            </div>
            <div class="col-15">
                <input type="text" v-model.number ="quoteobject.quote.de_zip_tax_rate_pct" />
            </div>
            <div class="col-30">
                <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label for="TotalMonthlyEquityBuildPayment">Total Mtly Equity Build Pmt</label>
                </div>
            </div>
            <div class="col-15">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label type="text" class="labelright">{{calcTotalMonthlyEquityBuildPayment}}</label>
               </div>
            </div>
            <div class="col-30">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label for="first12MonthsPaymentAmount">First 12 Months Pmt Amt</label>
               </div>
            </div>
            <div class="col-15">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label type="text" class="labelright">{{calcFirst12MonthsPmtAmount}}</label>
               </div>
            </div>
            </div>
              <div  class="frm-group" >

            <div class="col-30">
                 <label for="netPayDealer"> Net Pay Dealer </label>
            </div>
            <div class="col-15 font12">

                 <input type="radio" name="radio1" value="Y" v-model="quoteobject.quote.de_net_pay_dealer" class="maxwidth">Yes
                 <input type="radio" name="radio1" value="N" v-model="quoteobject.quote.de_net_pay_dealer" class="maxwidth">No
            </div>
            <div class="col-30">
                 <label for="TXTaxpaidByDealer"> TX Tax Paid By Dealer </label>
            </div>
            <div class="col-15 font12">
                 <input type="radio" name="radio2" value="Y" v-model="quoteobject.quote.de_tx_tax_pd_by_dealer" class="maxwidth">Yes
                 <input type="radio" name="radio2" value="N" v-model="quoteobject.quote.de_tx_tax_pd_by_dealer"  class="maxwidth">No
            </div>
            <div class="col-30">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label for="totalPreTaxBuildPayments">Total Pre-Tax Build Pmts</label>
               </div>
            </div>
            <div class="col-15">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label type="text" class="labelright">{{calcTotalPreTaxBuildPayments}}</label>
               </div>
            </div>
            <div class="col-30">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label for="totalEquityBuildPayments">Total Equity Build Pmts</label>
               </div>
            </div>
            <div class="col-15">
               <div v-if="this.quoteobject.quote.de_is_deferred_down == 'Y'">
               <label type="text" class="labelright">{{calcTotalEquityBuildPayments}}</label>
               </div>
            </div>

            </div>
            <div  class="frm-group" >
            <div class="col-16">
                 <label for="payDealerDMVFees"> Pay Dealer DMV Fees</label>
            </div>
            <div class="col-9 font12">
                 <input type="radio" name="radio3" v-model="quoteobject.quote.de_pay_dealer_dmv_fees" value="Y" class="maxwidth">Yes
                 <input type="radio" name="radio3" v-model="quoteobject.quote.de_pay_dealer_dmv_fees" value="N" class="maxwidth">No
            </div>
             <div class="col-16">
                <label for="isTradeTaxExcempt"> Is Trade Tax Excempt  </label>
            </div>
            <div class="col-9 font12">
                 <input type="radio" name="radio4" v-model="quoteobject.quote.de_is_trade_tax_exempt" value="Y" class="maxwidth">Yes
                 <input type="radio" name="radio4" v-model="quoteobject.quote.de_is_trade_tax_exempt" value="N" class="maxwidth">No
            </div>

            </div>
             <div  class="frm-group" >
            <div class="col-16">
                <label for="firstACHDate"> First ACH Date </label>
            </div>
            <div class="col-9">
               <input type="Date" v-model="quoteobject.quote.de_first_ach" />
            </div>
            <div class="col-16">
                  <label for="lastACHDate"> Last ACH Date </label>
            </div>
            <div class="col-9">
               <label type="Text">{{calcLastACHDate}}</label>
            </div>
         </div> </div>  </div>

   <div id="column">
<div class="marginzero heading" ><span><b>Vehicle Purchase Details</b></span>
<input class="clearbutton" type=button value="Clear" @click="clearVehiclePurchaseDetails()">
</div>
      <div class="card card-height-vd">
         <div  class="frm-group" >
            <div class="col-30">
               <label for="vehiclePrice"> Vehicle Price  </label>
            </div>
            <div class="col-15">
               <input type="text" v-model.number="quoteobject.quote.vd_vehicle_price" />
            </div>
            <div class="col-30">
                 <label for="tradeValue"> Trade Value </label>
            </div>
            <div class="col-15">
               <input type="text" v-model.number="quoteobject.quote.vd_trade_value"/>
            </div>
            <div class="col-30">
                 <label for="leaseCapCost"> Lease Cap Cost </label>
            </div>
            <div class="col-15">
               <label type="Text" class="labelright">{{calcLeaseCapCost}}</label>
            </div>
            <div class="col-30">
                <label for="llpInitialResidual"> Initial Residual </label>
            </div>
            <div class="col-15">
               <label type="Text" class="labelright">{{calcInitialResidual}}</label>
            </div>

    </div>
    <div  class="frm-group" >
            <div class="col-30">
               <label for="dealerTxnFee"> Dealer Txn Fee </label>
            </div>
            <div class="col-15">
               <input type="text" v-model.number="quoteobject.quote.vd_dealer_txn_fee"/>
            </div>
            <div class="col-30">
                 <label for="tradePayoff"> Trade Payoff </label>
            </div>
            <div class="col-15">
               <input type="text" v-model.number="quoteobject.quote.vd_trade_payoff "/>
            </div>
            <div class="col-30">
                 <label for="llpResidualAdjustment"> Residual Adjustment </label>
            </div>
            <div class="col-15">
                 <input type="Text"  v-model.number ="quoteobject.quote.vd_llp_residual_adjustment" />
            </div>
            <div class="col-30">
                  <label for="residualRevenue"> Residual Revenue </label>
            </div>
            <div class="col-15">
                 <input type="Text"  v-model.number ="quoteobject.quote.vd_residual_revenue" />
            </div>
         </div>
         <div  class="frm-group">
            <div class="col-30">
               <label for="totalPrice"> Total Price </label>
            </div>
            <div class="col-15">
               <label type="Text" class="labelright">{{calcTotalPrice}}</label>
            </div>
            <div class="col-30">
                 <label for="tradeCredit"> Trade Credit </label>
            </div>
            <div class="col-15">
               <label type="Text" class="labelright">{{calcTradeCredit}}</label>
            </div>
            <div class="col-30">
                <label for="leaseResidual"> Lease Residual </label>
            </div>
            <div class="col-15">
               <label type="Text" class="labelright">{{calcLeaseResidual}}</label>
            </div>
            <div class="col-30">
                <label for="llpFinalResidual"> Final Residual </label>
            </div>
            <div class="col-15">
               <label type="Text" class="labelright">{{calcLLPFinalResidual}}</label>
            </div>
         </div>
         <div  class="frm-group">
            <div class="col-30">
               <label for="cashCapReduction"> Cash Cap Reduction </label>
            </div>
            <div class="col-15">
               <label type="Text" class="labelright">{{calcCashCapReduction}}</label>
            </div>
            <div class="col-30">
                <label for="cashCapReduction"> Total Cap Reduction </label>
            </div>
            <div class="col-15">
               <label type="Text" class="labelright"> {{calcTotalCapReduction}}</label>
            </div>
            <div class="col-30">
                <label for="totalCapCostReduction"> Credit Score</label>
            </div>
            <div class="col-15">
                <input  type="Text" v-model= "quoteobject.quote.credit_score">
            </div>
            <div class="col-30">
                <label for="loanAmount"> Loan Amount </label>
            </div>
            <div class="col-15">
               <label type="Text" class="labelright">{{calcLoanAmount}}</label>
            </div>
         </div>

      </div></div>

    <div id="marginright">
    <input id="tabbutton" type="button" value="Clear" @click="clearAll()">
    <input id="tabbutton" type="button" @click="quoteobject.quote.tabIndex++" value="Next">
    <input  id="tabbutton" type="button" @click="quoteobject.quote.tabIndex--" value="Back">
     <div id="savelaterfinancial">
       <input type="submit" value="Save Later" id="tabbutton" @click="savelaterpopup()">
         </div>
</div>
<div id="savefinancial" class="popup">
         <div class="popup-topcontent" >
              <span>Save Later</span>

            <span class="savelaterfinancialclose" id="test">x</span>
            </div>
         <div class="popup-content"> <center>
        <p>Are you sure you want to save this for a later use?</p>
         <input type="submit" value="Yes" id="customerbutton">
         <input type="submit" value="No" id="customerbutton"></center>
              </div>
         </div>
 </div>

      <!-- End of the code for this screen here -->
</template>
<script>
import commonservice from '../js/http-common'
import moment from 'moment'
import vendorintegration from '../js/http-vendorintegration'
export default {
  props: ['quoteobject'],
  components: {

  },
  name: 'DealInputFinancials',
  data () {
    return {
      states: [],
      previous_de_total_payments: '',
      state: '',
      previous_de_initial_equity_target_pct: '',
      previous_de_exit_equity_target_pct: null,
      previous_de_lease_funding_cost_pct: null

    }
  },
  methods: {
    clearElements () {
      this.quoteobject.quote.de_initial_equity_target_pct = ''
      this.quoteobject.quote.de_exit_equity_target_pct = ''
      this.quoteobject.quote.de_loan_funding_cost = ''
      this.quoteobject.quote.de_lease_funding_cost_pct = ''
      this.quoteobject.quote.de_first_ach = ''
      this.quoteobject.quote.de_net_pay_dealer = ''
      this.quoteobject.quote.de_pay_dealer_dmv_fees = ''
      this.quoteobject.quote.de_tx_tax_pd_by_dealer = ''
      this.quoteobject.quote.de_is_trade_tax_exempt = ''
      this.quoteobject.quote.zip_code = ''
      this.quoteobject.quote.de_zip_tax_rate_pct = ''
      this.quoteobject.quote.de_county_tax_rate_pct = ''
      this.quoteobject.quote.de_state_tax_rate_pct = ''
      this.quoteobject.quote.de_state_of_registration = ''
      this.quoteobject.quote.de_initial_equity_target = ''
      this.quoteobject.quote.de_equity_build_period = ''
      this.quoteobject.quote.city = ''
    },
    clearVehiclePurchaseDetails () {
      this.quoteobject.quote.vd_vehicle_price = ''
      this.quoteobject.quote.vd_trade_value = ''
      this.quoteobject.quote.vd_dealer_txn_fee = ''
      this.quoteobject.quote.vd_trade_payoff = ''
      this.quoteobject.quote.vd_llp_residual_adjustment = ''
      this.quoteobject.quote.vd_residual_revenue = ''
    },

    clearAll () {
      this.clearElements()
      this.clearVehiclePurchaseDetails()
      this.clearLeaseDetails()
    },
    getzipcode () {
      vendorintegration.get('demographic/zipcode/' + parseInt(this.quoteobject.quote.zip_code)).then(response => {
        this.quoteobject.quote.city = response.data.cityName
        this.state = response.data.stateCode
        this.quoteobject.quote.de_state_of_registration = response.data.stateCode
      })
    },
    clearzipcode () {
      if (this.state == this.quoteobject.quote.de_state_of_registration) {
        this.quoteobject.quote.city = response.data.cityName
        this.quoteobject.quote.de_state_of_registration = response.data.stateCode
      } else {
        this.quoteobject.quote.city = ' '
        this.quoteobject.quote.zip_code = ' '
      }
    },

    handleInput (e) {
      let stringValue = e.target.value.toString()
      let regex = /^\d{1,2}(\.$|\.\d{1,2}$|$)/
      if (!stringValue.match(regex) && this.quoteobject.quote.de_initial_equity_target_pct !== '') {
        this.quoteobject.quote.de_initial_equity_target_pct = this.previous_de_initial_equity_target_pct
      }
      if (!stringValue.match(regex) && this.quoteobject.quote.de_exit_equity_target_pct !== '') {
        this.quoteobject.quote.de_exit_equity_target_pct = this.previous_de_exit_equity_target_pct
      }
      this.previous_de_initial_equity_target_pct = this.quoteobject.quote.de_initial_equity_target_pct
      this.previous_de_exit_equity_target_pct = this.quoteobject.quote.de_exit_equity_target_pct
    },

    fetchData () {
      commonservice.get('/statefip/').then(response => {
        this.states = response.data
        // console.log(response.data)
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    savelaterpopup () {
      var popup = document.getElementById('savefinancial')
      var btn = document.getElementById('savelaterfinancial')
      var span = document.getElementsByClassName('savelaterfinancialclose')[0]
      btn.onclick = function () {
        popup.style.display = 'block'
      }
      span.onclick = function () {
        popup.style.display = 'none'
      }

      window.onclick = function (event) {
        if (event.target == popup) {
          popup.style.display = 'none'
        }
      }
    }
  },

  computed: {
    calcInitialWholesaleValue () {
      if (this.quoteobject.quote.at_inception != '') {
        this.quoteobject.quote.de_initial_wholesale_value = this.quoteobject.quote.at_inception
        return this.quoteobject.quote.de_initial_wholesale_value
      } else return this.quoteobject.quote.de_initial_wholesale_value
    },
    calcExitWholesaleValue () {
      if (this.quoteobject.quote.de_remaining_payments >= 1 && this.de_remaining_payments <= 12) {
        this.quoteobject.quote.de_exit_wholesale_value = this.quoteobject.quote.at_month_12
        return this.quoteobject.quote.de_exit_wholesale_value
      }
      if (this.quoteobject.quote.de_remaining_payments >= 13 && this.de_remaining_payments <= 24) {
        this.quoteobject.quote.de_exit_wholesale_value = this.quoteobject.quote.at_month_24
        return this.quoteobject.quote.de_exit_wholesale_value
      }
      if (this.quoteobject.quote.de_remaining_payments >= 25 && this.quoteobject.quote.de_remaining_payments <= 36) {
        this.quoteobject.quote.de_exit_wholesale_value = this.quoteobject.quote.at_month_36
        return this.quoteobject.quote.de_exit_wholesale_value
      }
      if (this.quoteobject.quote.de_remaining_payments >= 37 && this.quoteobject.quote.de_remaining_payments <= 48) {
        this.quoteobject.quote.de_exit_wholesale_value = this.quoteobject.quote.at_month_48
        return this.quoteobject.quote.de_exit_wholesale_value
      }
      if (this.quoteobject.quote.de_remaining_payments >= 49 && this.quoteobject.quote.de_remaining_payments <= 58) {
        this.quoteobject.quote.de_exit_wholesale_value = this.quoteobject.quote.at_month_58
        return this.quoteobject.quote.de_exit_wholesale_value
      }
      if (this.quoteobject.quote.de_remaining_payments >= 59 && this.quoteobject.quote.de_remaining_payments <= 72) {
        this.quoteobject.quote.de_exit_wholesale_value = this.quoteobject.quote.at_month_72
        return this.quoteobject.quote.de_exit_wholesale_value
      }
    },

    calcTotalPrice () {
      if (this.quoteobject.quote.vd_dealer_txn_fee != '' || this.quoteobject.quote.vd_vehicle_price != '') {
        this.quoteobject.quote.vd_total_price = this.quoteobject.quote.vd_vehicle_price + this.quoteobject.quote.vd_dealer_txn_fee
        return this.quoteobject.quote.vd_total_price
      }
    },
    calcTradeCredit () {
      if (this.quoteobject.quote.vd_trade_value != '' || this.quoteobject.quote.vd_trade_payoff != '') {
        this.quoteobject.quote.vd_trade_credit = this.quoteobject.quote.vd_trade_value - this.quoteobject.quote.vd_trade_payoff
        return this.quoteobject.quote.vd_trade_credit
      }
      return this.quoteobject.quote.vd_trade_credit
    },
    calcLLPFinalResidual () {
      if (this.quoteobject.quote.vd_llp_initial_residual != '' || this.quoteobject.quote.vd_llp_residual_adjustment != '') {
        this.quoteobject.quote.vd_llp_final_residual = this.quoteobject.quote.vd_llp_initial_residual + this.quoteobject.quote.vd_llp_residual_adjustment
        return this.quoteobject.quote.vd_llp_final_residual
      }
      return this.quoteobject.quote.vd_llp_final_residual
    },
    calcLeaseResidual () {
      if (this.quoteobject.quote.vd_llp_final_residual != '' || this.quoteobject.quote.vd_residual_revenue != '') {
        this.quoteobject.quote.vd_lease_residual = parseInt(this.quoteobject.quote.vd_llp_final_residual) + this.quoteobject.quote.vd_residual_revenue
        return this.quoteobject.quote.vd_lease_residual
      }
      return this.quoteobject.quote.vd_lease_residual
    },
    calcCashCapReduction () {
      if (this.quoteobject.quote.vd_total_price != '') {
        this.quoteobject.quote.vd_cash_cap_reduction = (this.quoteobject.quote.vd_total_price - (parseInt(this.quoteobject.quote.de_initial_wholesale_value) *
            (1 - this.quoteobject.quote.de_initial_equity_target_pct / 100))) - (parseInt(this.quoteobject.quote.vd_trade_value) - parseInt(this.quoteobject.quote.vd_trade_payoff)) - Number(this.quoteobject.quote.de_deferred_equity_amount)
        return this.quoteobject.quote.vd_cash_cap_reduction
      }
    },
    calcTotalCapReduction () {
      this.quoteobject.quote.vd_total_cap_reduction = Number(this.quoteobject.quote.vd_cash_cap_reduction) + Number(this.quoteobject.quote.vd_trade_credit)
      return this.quoteobject.quote.vd_total_cap_reduction
    },
    calcLeaseCapCost () {
      this.quoteobject.quote.vd_lease_cap_cost = this.quoteobject.quote.vd_vehicle_price - parseInt(this.quoteobject.quote.vd_total_cap_reduction)
      return this.quoteobject.quote.vd_lease_cap_cost
    },
    calcInitialResidual () {
      if (this.quoteobject.quote.de_exit_wholesale_value != '' && this.quoteobject.quote.de_exit_equity_target_pct != '') {
        this.quoteobject.quote.vd_llp_initial_residual = Math.round(this.quoteobject.quote.de_exit_wholesale_value *
                                (1 - ((this.quoteobject.quote.de_exit_equity_target_pct / 100))))
        return this.quoteobject.quote.vd_llp_initial_residual
      } else { return 'key Inputs' }
    },
    calcLastACHDate () {
      if (this.quoteobject.quote.de_first_ach == '') {
        return 'Need 1st ACH Date'
      } else {
        var currentDate = moment(this.quoteobject.quote.de_first_ach)
        var futureMonth = moment(currentDate).add(8, 'M')
        var futureMonthEnd = moment(futureMonth).endOf('month')
        this.quoteobject.quote.de_last_ach = futureMonthEnd.format('MM/DD/YYYY')
        // console.log(this.quoteobject.quote.de_last_ach )
        return this.quoteobject.quote.de_last_ach
      }
    },

    calcSecondaryEquityPeriod () {
      if (this.quoteobject.quote.de_is_deferred_down == 'Y') {
        this.quoteobject.quote.de_secondary_equity_build = this.quoteobject.quote.de_initial_equity_target_pct - this.quoteobject.quote.de_initial_equity_target
        return Number(this.quoteobject.quote.de_secondary_equity_build).toFixed(2)
      } else { return 0 }
    },
    calcDeferredEquityAmount () {
      if (this.quoteobject.quote.de_is_deferred_down == 'Y') {
        this.quoteobject.quote.de_deferred_equity_amount = Number(this.quoteobject.quote.de_secondary_equity_build / 100) * Number(this.quoteobject.quote.de_initial_wholesale_value)
        return Number(this.quoteobject.quote.de_deferred_equity_amount).toFixed(2)
      } else return 0
    },
    calcMonthlyEquityBuildPayment () {
      if (this.quoteobject.quote.de_is_deferred_down == 'Y') {
        var a = (this.quoteobject.quote.de_lease_funding_cost_pct / 100)// rate
        var b = Number(a / 12)
        var c = Number(this.quoteobject.quote.de_equity_build_period)// npr
        var d = -this.quoteobject.quote.de_deferred_equity_amount// pv
        var e = Number(0)// fv
        var x = Math.pow(1 + b, 12)
        this.quoteobject.quote.de_monthly_equity_build_payment = -((b * (0 + x * d)) / (-1 + x))
        if (isNaN(this.quoteobject.quote.de_monthly_equity_build_payment)) { return 0 } else { return Number(this.quoteobject.quote.de_monthly_equity_build_payment).toFixed(2) }
      } else return 0
    },
    calcTaxOnMonthlyEquityBuildPayment () {
      if (this.quoteobject.quote.de_is_deferred_down == 'Y') {
        if (this.quoteobject.quote.de_state_of_registration == '') { return 'Enter State' } else if (this.quoteobject.quote.de_state_of_registration == 'AZ' || this.quoteobject.quote.de_state_of_registration == 'CA' ||
            this.quoteobject.quote.de_state_of_registration == 'CO' || this.quoteobject.quote.de_state_of_registration == 'CT' ||
            this.quoteobject.quote.de_state_of_registration == 'DE' || this.quoteobject.quote.de_state_of_registration == 'FL' || this.quoteobject.quote.de_state_of_registration == 'IN' ||
            this.quoteobject.quote.de_state_of_registration == 'MA' || this.quoteobject.quote.de_state_of_registration == 'MI' || this.quoteobject.quote.de_state_of_registration == 'NC' ||
            this.quoteobject.quote.de_state_of_registration == 'NH' || this.quoteobject.quote.de_state_of_registration == 'NV' || this.quoteobject.quote.de_state_of_registration == 'TN' ||
            this.quoteobject.quote.de_state_of_registration == 'UT' || this.quoteobject.quote.de_state_of_registration == 'PA' || this.quoteobject.quote.de_state_of_registration == 'WA') {
          this.quoteobject.quote.de_tax_on_monthly_equity_build_payment = (this.quoteobject.quote.de_monthly_equity_build_payment *
            ((this.quoteobject.quote.de_state_tax_rate_pct) / 100 + (this.quoteobject.quote.de_county_tax_rate_pct) / 100 + (this.quoteobject.quote.de_zip_tax_rate_pct) / 100)).toFixed(2)
          if (isNaN(this.quoteobject.quote.de_tax_on_monthly_equity_build_payment)) { return 0 } else { return Number(this.quoteobject.quote.de_tax_on_monthly_equity_build_payment) }
        }
      } else return 0
    },
    calcTotalMonthlyEquityBuildPayment () {
      if (this.quoteobject.quote.de_is_deferred_down == 'Y') {
        this.quoteobject.quote.de_total_monthly_equity_build_payment = Number(this.quoteobject.quote.de_monthly_equity_build_payment) + Number(this.quoteobject.quote.de_tax_on_monthly_equity_build_payment)
        if (isNaN(this.quoteobject.quote.de_total_monthly_equity_build_payment)) { return 0 } else { return Number(this.quoteobject.quote.de_total_monthly_equity_build_payment).toFixed(2) }
      } else return 0
    },
    calcTotalPreTaxBuildPayments () {
      if (this.quoteobject.quote.de_is_deferred_down == 'Y') {
        this.quoteobject.quote.de_total_pre_tax_build_payments = Number(this.quoteobject.quote.de_monthly_equity_build_payment) * Number(this.quoteobject.quote.de_equity_build_period)
        if (isNaN(this.quoteobject.quote.de_total_pre_tax_build_payments)) { return 0 } else { return Number(this.quoteobject.quote.de_total_pre_tax_build_payments).toFixed(2) }
      } else { return 0 }
    },
    calcFirst12MonthsPmtAmount () {
      if (this.quoteobject.quote.de_is_deferred_down == 'Y') {
        this.quoteobject.quote.de_first_12months_payment_amount = Number(this.quoteobject.quote.de_total_monthly_equity_build_payment) + Number(this.quoteobject.quote.ld_final_monthly_lease_payment)
        if (isNaN(this.quoteobject.quote.de_first_12months_payment_amount)) { return 0 } else { return Number(this.quoteobject.quote.de_first_12months_payment_amount).toFixed(2) }
      } else return 0
    },
    calcTotalEquityBuildPayments () {
      if (this.quoteobject.quote.de_is_deferred_down == 'Y') {
        this.quoteobject.quote.de_total_equity_build_payments = Number(this.quoteobject.quote.de_total_monthly_equity_build_payment) * Number(this.quoteobject.quote.de_equity_build_period)
        if (isNaN(this.quoteobject.quote.de_total_equity_build_payments)) { return 0 } else { return Number(this.quoteobject.quote.de_total_equity_build_payments).toFixed(2) }
      } else return 0
    },
    calcLoanAmount () {
      this.quoteobject.quote.lm_loan_amount = this.quoteobject.quote.vd_total_price - this.quoteobject.quote.vd_total_cap_reduction
      return Number(this.quoteobject.quote.lm_loan_amount).toFixed(2)
    }

  },

  mounted () {
    this.fetchData()
  }

}
</script>
<style scoped>

 .frm-group {
    /** display: -webkit-flex;  **/
    display: flex;
    flex-flow: row;
    align-items: left;
    width:100%;
}
.font12{
    font-size: 12px;
    line-height: 0.5
}
.frm-group label {
    text-align: left;
    font-size: 12px;
    vertical-align: bottom;
    margin: 8px 15px 0px 10px;
    display:block;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.frm-group input {
    width: 100%;
    white-space: nowrap;
    border: 1px solid #ddd;
    border-radius: 5px;
    resize: vertical;
    font-size:12px;
    margin: 5px 10px 0px 0px;
}

.frm-group input[type="Date"]{
    padding: 6px
}
.frm-group input[type="number"]{
    font-size: 12px
}

.frm-group select {
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size:12px;
    resize: vertical;
    margin: 5px 10px 0px 0px;

}

#column {
  float: left;
  width: 100%;
  padding: 1px;
}
#column1 {
  float: left;
  width: 100%;
  padding: 1px;
}
.marginleft{
    margin-left: 6.5%
}
.card-height{
height:225px;
padding-top:0px
}
.card-height-vd{
   height:125px;
   padding-top: 0px
}

.col-8{
    float:right;
    width:8%;
    font-size: 12px;
}
.col-16{
   width:16.6%
}
.col-17{
   width:17%
}
.col-9{
   width:8.4%
}
.maxwidth{
   max-width:10%;
}
.popup {
   display: none;
   position: fixed;
   z-index: 1;
   padding-top: 100px;
   left: 0;
   top: 0;
   width: 100%;
   height: 100%;
   overflow: auto;
   background-color: rgb(0,0,0);
   background-color: rgba(0,0,0,0.4);
   }
   .popup-content {
   overflow: hidden;
    border:1px solid #00529B;
    background:white;
    padding: 10px 0px 10px 0px;
    border-top:none;
    width:45%;
    margin:0px 400px;

   }

   .popup-topcontent{
   background-color: dodgerblue;
   margin: 0px 400px;
   padding: 10px 10px 10px 10px;
   width: 45%;
   border:1px solid #00529B;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
   font-size : 14px;
   color: white;
    margin-top:2%;
   }
   .savelaterfinancialclose {
   color: black;
   float: right;
   font-size: 16px;
   font-weight: bold;
   padding: 0px 10px 0px 0px;
   }
   .savelaterfinancialclose:hover,
   .savelaterfinancialclose:focus {
   color: #000;
   text-decoration: none;
   cursor: pointer;
   }

#tabbutton{
    float:right;
    color: white;
    padding: 6px 20px;
    background-color: dodgerblue;
    border: 1px solid #ddd;
    margin: 10px 0px 0px 0px;
}
#marginright{
    margin-right: 10%
}
.clearbutton{
   float:right;
    background-color: dodgerblue;
    border: 1px solid #ddd;
    color: white;
    cursor: pointer;
   border-radius:5px;
   padding: 3px 20px 3px 20px;

}
.labelright{
    float:right
}
@media  (max-width: 1100px){

    .card-height{
        height:380px;
   padding-top:0px;
   width:100%;
   overflow:scroll;

    }
    .card-height-vd{
       height:280px;
   padding-top:0px;
   overflow:scroll;
    }
    .col-16{
       float:right;
      width:100%
   }

   .col-9{
      float:right;
      width:100%
   }

   .col-30{
      float:right;
      width:100%
   }

   .col-15{
        float:right;
      width:100%
   }
    .frm-group{
      align-items: stretch;
      flex-direction: column;
      width:100%

    }
}
@media  (max-width: 800px){
   .col-16{
      width:100%
   }

   .col-9{
      width:100%
   }

   .col-15{
      width:10%
   }

   .col-30{
      width:50%
   }

}

</style>
